<template>
    <span class="user-icon">
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.5 8.31412C10.3901 8.31412 11.9225 6.45296 11.9225 4.15708C11.9225 1.86116 11.4194 0 8.5 0C5.58062 0 5.07742 1.86116 5.07742 4.15708C5.07742 6.45296 6.6098 8.31412 8.5 8.31412Z"
                :fill="fill"
            />
            <path
                d="M2.03559 14.6614C2.035 14.5214 2.03442 14.622 2.03559 14.6614V14.6614Z"
                :fill="fill"
            />
            <path
                d="M14.9641 14.7708C14.966 14.7324 14.9648 14.5049 14.9641 14.7708V14.7708Z"
                :fill="fill"
            />
            <path
                d="M14.9569 14.4936C14.8935 10.4941 14.3711 9.35448 10.374 8.6331C10.374 8.6331 9.81139 9.35006 8.49996 9.35006C7.18853 9.35006 6.62578 8.6331 6.62578 8.6331C2.67231 9.34661 2.11821 10.4693 2.04535 14.3637C2.03937 14.6817 2.03661 14.6984 2.03554 14.6615C2.03578 14.7306 2.03607 14.8586 2.03607 15.0816C2.03607 15.0816 2.98768 17 8.49996 17C14.0121 17 14.9639 15.0816 14.9639 15.0816C14.9639 14.9383 14.964 14.8386 14.9641 14.7708C14.963 14.7937 14.9609 14.7494 14.9569 14.4936Z"
                :fill="fill"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconUser',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
